import clsx from 'clsx';
import React from 'react';
const FormSection = ({ className, children, style }) => (React.createElement("div", { className: clsx('mb-7', 'max-w-full', 'form-section', className), style: style }, children));
export default FormSection;
